

export const aboutData = {
    title: "eBudsDAC",
    description1: "eBuds is a fair and transparent NFT project, where everyone can join, contribute and take advantage of the benefits.",
    description2: "eBuds team members are not taking any fees, they are investing their time and money to build a strong community, with a long term vision.",
    description3:  "eBuds is built on MultiversX and is a decentralized autonomous Community that is governed by the eBudsDAC. The eBudsDAC manages the $EBUD Token, a cryptocurrency that is used to power the eBuds ecosystem.",
    image: 2 ,
}